import { PURCHASE_PREPAID_SUBSCRIPTION_REQUEST, PURCHASE_PREPAID_SUBSCRIPTION_SUCCESS, PURCHASE_PREPAID_SUBSCRIPTION_ERROR } from '../types';
const purchasePrepaidSubscriptionRequest = payload => ({
  type: PURCHASE_PREPAID_SUBSCRIPTION_REQUEST,
  payload
});
const purchasePrepaidSubscriptionError = (error, payload) => ({
  type: PURCHASE_PREPAID_SUBSCRIPTION_ERROR,
  payload,
  error
});
const purchasePrepaidSubscriptionSuccess = (payload, cart, lineItem, prepaidSubscription) => ({
  type: PURCHASE_PREPAID_SUBSCRIPTION_SUCCESS,
  payload,
  cart,
  lineItem,
  prepaidSubscription
});
export const purchasePrepaidSubscription = payload => async (dispatch, getState, _ref) => {
  let {
    chord
  } = _ref;
  dispatch(purchasePrepaidSubscriptionRequest(payload));
  const {
    auth
  } = getState();
  try {
    let cart = await chord.oms.createOrder(auth.token);
    const orderIdentifier = {
      number: cart.number,
      token: cart.token
    };
    await chord.oms.addLineItem(orderIdentifier, auth.token, payload);
    cart = await chord.oms.prepareCheckout(orderIdentifier, auth.token);
    const lineItem = cart.lineItems.find(li => li.variant.sku === payload.lineItem.sku);
    const prepaidSubscription = lineItem.prePaidSubscription;
    dispatch(purchasePrepaidSubscriptionSuccess(payload, cart, lineItem, prepaidSubscription));
    return cart;
  } catch (e) {
    dispatch(purchasePrepaidSubscriptionError(e, payload));
    throw e;
  }
};